<template>
    <div class="menu-manage">
        <!-- 工具栏 -->
        <div class="toolbar" style="margin-bottom: 10px;">
            <el-button type="primary" icon="el-icon-plus" size="mini" @click="handleAddMenu">新增菜单</el-button>
            <el-button icon="el-icon-refresh" size="mini" @click="handleRefresh">刷新</el-button>
            <el-button icon="el-icon-s-fold" size="mini" @click="handleExpandAll">{{ isExpand ? '折叠' : '展开'
                }}</el-button>
        </div>

        <!-- 树形菜单列表（懒加载） -->
        <el-table :data="menuTableData" style="width: 100%;margin-bottom: 20px;height: 80vh;overflow: auto;"
            row-key="menuId" border :default-expand-all="false"
            :tree-props="{ children: 'children', hasChildren: 'hasChildren' }" lazy :load="loadMenuChildren"
            ref="menuTable">
            <el-table-column prop="menuId" label="菜单ID" align="center" width="80"></el-table-column>
            <el-table-column prop="menuName" label="菜单名称" min-width="180">
                <template #default="scope">
                    <span style="margin-left: 8px;">
                        <i :class="scope.row.icon" v-if="scope.row.icon" style="margin-right: 5px;"></i>
                        {{ scope.row.menuName }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column prop="menuType" label="菜单类型" align="center" width="100">
                <template #default="scope">
                    <el-tag size="mini"
                        :type="scope.row.menuType === 'C' ? 'success' : (scope.row.menuType === 'M' ? 'primary' : 'info')">
                        {{ scope.row.menuType === 'C' ? '目录' : '菜单' }}
                    </el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="path" label="路由地址" min-width="180"></el-table-column>
            <el-table-column prop="index" label="排序" align="center" width="80"></el-table-column>
            <el-table-column label="操作" align="center" width="200" class-name="small-padding fixed-width">
                <template #default="scope">
                    <el-button type="text" size="mini" icon="el-icon-edit" @click="handleEdit(scope.row)">修改</el-button>
                    <el-button type="text" size="mini" icon="el-icon-plus"
                        @click="handleAddChildMenu(scope.row)">新增</el-button>
                    <el-button type="text" size="mini" icon="el-icon-delete" style="color: #f56c6c;"
                        @click="handleDelete(scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <!-- 1. 新增菜单弹窗 -->
        <el-dialog :title="addDialogTitle" :visible.sync="addDialogVisible" width="500px" top="20vh" :z-index="13000"
            append-to-body>
            <el-form ref="addMenuForm" :model="addMenuForm" :rules="menuRules" label-width="80px" size="mini">
                <el-form-item label="菜单名称" prop="menuName">
                    <el-input v-model="addMenuForm.menuName" placeholder="请输入菜单名称"></el-input>
                </el-form-item>
                <el-form-item label="路由地址" prop="path">
                    <el-input v-model="addMenuForm.path" placeholder="请输入路由地址 (以/开头)"></el-input>
                </el-form-item>
                <el-form-item label="菜单组件" prop="component">
                    <el-input v-model="addMenuForm.component" placeholder="请输入菜单组件路径 (.vue文件路径)"></el-input>
                </el-form-item>
                <el-form-item label="菜单图标" prop="icon">
                    <el-input v-model="addMenuForm.icon" placeholder="例如：el-icon-menu"></el-input>
                    <div style="margin-top: 5px;" v-if="addMenuForm.icon">
                        <i :class="addMenuForm.icon" style="font-size: 24px;"></i>
                    </div>
                </el-form-item>
                <el-form-item label="排序" prop="index">
                    <el-input v-model="addMenuForm.index" style="width: 100%;"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="mini" @click="addDialogVisible = false">取消</el-button>
                <el-button size="mini" type="primary" @click="handleAddSubmit">确定</el-button>
            </div>
        </el-dialog>

        <!-- 2. 修改菜单弹窗 (已添加上级目录选择) -->
        <el-dialog :title="editDialogTitle" :visible.sync="editDialogVisible" width="500px" top="20vh" :z-index="13001"
            append-to-body>
            <el-form ref="editMenuForm" :model="editMenuForm" :rules="menuRules" label-width="80px" size="mini">
                <el-form-item label="上级菜单" prop="parentId">
                    <el-cascader v-model="editMenuForm.parentId" :options="cascaderOptions" :props="cascaderProps"
                        clearable placeholder="选择上级菜单，不选为顶级菜单" style="width: 100%;"></el-cascader>
                </el-form-item>
                <el-form-item label="菜单名称" prop="menuName">
                    <el-input v-model="editMenuForm.menuName" placeholder="请输入菜单名称"></el-input>
                </el-form-item>
                <el-form-item label="路由地址" prop="path">
                    <el-input v-model="editMenuForm.path" placeholder="请输入路由地址 (以/开头)"></el-input>
                </el-form-item>
                <el-form-item label="菜单组件" prop="component">
                    <el-input v-model="editMenuForm.component" placeholder="请输入菜单组件路径 (.vue文件路径)"></el-input>
                </el-form-item>
                <el-form-item label="菜单图标" prop="icon">
                    <el-input v-model="editMenuForm.icon" placeholder="例如：el-icon-menu"></el-input>
                    <div style="margin-top: 5px;" v-if="editMenuForm.icon">
                        <i :class="editMenuForm.icon" style="font-size: 24px;"></i>
                    </div>
                </el-form-item>
                <el-form-item label="排序" prop="index">
                    <el-input v-model="editMenuForm.index" style="width: 100%;"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="mini" @click="editDialogVisible = false">取消</el-button>
                <el-button size="mini" type="primary" @click="handleEditSubmit">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { getListMenu, addMenu, editMenu, deleteMenu } from "@/api/systemMenu";

// 生成唯一临时ID的工具函数
const generateTempId = (() => {
    let counter = 0;
    return () => `temp_${Date.now()}_${counter++}`;
})();

export default {
    name: "SystemMenuView",
    data() {
        return {
            menuTableData: [],
            fullMenuData: [],
            isExpand: false,
            addDialogVisible: false,
            addDialogTitle: "新增菜单",
            addMenuForm: { pid: null, menuName: "", menuType: "M", icon: "", path: "", index: 0, component: "" },
            editDialogVisible: false,
            editDialogTitle: "修改菜单",
            editMenuForm: { menuId: null, parentId: null, menuName: "", menuType: "", icon: "", path: "", index: 0, component: "" },
            menuRules: {
                menuName: [{ required: true, message: "请输入菜单名称", trigger: "blur" }],
                path: [{ required: true, message: "请输入路由地址", trigger: "blur" }],
                component: [{ required: true, message: "请输入菜单组件路径", trigger: "blur" }],
                index: [{ required: true, message: "请输入排序号", trigger: "blur" }],
            },
            cascaderOptions: [],
            cascaderProps: { value: 'menuId', label: 'menuName', children: 'children', checkStrictly: true, emitPath: false },
        };
    },
    async created() {
        await this.loadMenuData();
    },
    methods: {
        async loadMenuData() {
            const loading = this.$loading({ text: "加载中..." });
            try {
                const response = await getListMenu();
                if (response && response.code === 200) {
                    this.fullMenuData = response.data
                    // 根菜单格式化：直接用menuId
                    this.menuTableData = this.formatDataForTable(this.fullMenuData);
                    console.log("根菜单数据：", this.menuTableData);
                    this.generateCascaderOptions(this.fullMenuData);
                } else {
                    this.$message.error("加载菜单失败：" + (response.msg || '未知错误'));
                }
            } catch (error) {
                console.error("加载菜单异常:", error);
                this.$message.error("加载菜单异常，请检查网络或联系管理员");
            } finally {
                loading.close();
            }
        },

        /**
         * 懒加载逻辑：精准匹配当前节点的子菜单 + 传递父menuId用于生成唯一子menuId
         */
        loadMenuChildren(treeNode, treeNodeComponent, resolve) {
            const parentMenuId = String(treeNode.menuId);
            console.log("当前点击的节点menuId：", parentMenuId);

            // 只根据menuId查找目标节点
            const targetNode = this.findTargetNodeByMenuId(this.fullMenuData, parentMenuId);
            const children = targetNode?.children || [];

            console.log("匹配到的子菜单：", children);
            // 子菜单格式化：传入父menuId生成唯一key
            resolve(this.formatDataForTable(children, parentMenuId));
        },

        /**
         * 只根据menuId查找目标节点（不再匹配id）
         */
        findTargetNodeByMenuId(data, targetMenuId) {
            if (!Array.isArray(data) || !targetMenuId) return null;

            for (const item of data) {
                if (String(item.menuId) === targetMenuId) {
                    return item;
                }
                if (item.children && item.children.length > 0) {
                    const found = this.findTargetNodeByMenuId(item.children, targetMenuId);
                    if (found) return found;
                }
            }
            return null;
        },

        /**
         * 格式化数据：解决key重复问题
         * @param {Array} data 要格式化的菜单数据
         * @param {String} parentMenuId 父节点menuId（子菜单必填）
         * @returns {Array} 格式化后的数据
         */
        formatDataForTable(data, parentMenuId = '') {
            if (!Array.isArray(data)) return [];

            return data.map(item => {
                let safeMenuId = '';

                // 根菜单：直接用menuId（保证唯一）
                if (item.menuId) {
                    safeMenuId = String(item.menuId);
                }
                // 子菜单：用「父menuId-子id」生成唯一key（核心修复）
                else if (item.id && parentMenuId) {
                    safeMenuId = `${parentMenuId}-${item.id}`;
                }
                // 兜底：生成临时ID
                else {
                    safeMenuId = generateTempId();
                    item._tempId = safeMenuId;
                }

                return {
                    menuId: safeMenuId,       // 唯一key：根=menuId，子=父menuId-子id
                    menuName: item.title || '未命名',
                    parentId: item.pid || parentMenuId,
                    menuType: item.menuType || (item.children && item.children.length > 0 ? 'C' : 'M'),
                    icon: item.icon || '',
                    path: item.path || '',
                    index: item.index || '',
                    component: item.component || '',
                    hasChildren: (item.children && item.children.length > 0) || false,
                    originalId: item.id || item.menuId, // 保留原始ID用于增删改查
                    rawMenuId: item.menuId, // 保留原始menuId（用于回显）
                };
            });
        },

        generateCascaderOptions(data) {
            const buildOptions = (list, parentMenuId = '') => {
                return list.map(item => {
                    // 级联选择器的key也要唯一
                    const nodeId = item.menuId
                        ? String(item.menuId)
                        : (item.id && parentMenuId ? `${parentMenuId}-${item.id}` : generateTempId());

                    if (!nodeId) return null;

                    const node = { menuId: nodeId, menuName: item.title || '未命名' };
                    if (item.children && item.children.length > 0) {
                        node.children = buildOptions(item.children, item.menuId ? String(item.menuId) : nodeId).filter(Boolean);
                    }
                    return node;
                });
            };
            this.cascaderOptions = buildOptions(data).filter(Boolean);
        },

        // --- 操作方法（适配新的menuId格式） ---
        handleRefresh() {
            this.loadMenuData();
            this.$message.success("刷新成功");
        },

        handleExpandAll() {
            this.isExpand = !this.isExpand;
            this.$refs.menuTable?.toggleAllRowsExpanded(this.isExpand);
        },

        handleAddMenu() {
            this.addDialogTitle = "新增顶级菜单";
            this.resetAddForm();
            this.addMenuForm.pid = null;
            this.addDialogVisible = true;
        },

        handleAddChildMenu(row) {
            this.addDialogTitle = `新增【${row.menuName}】的子菜单`;
            this.resetAddForm();
            // 新增子菜单时，pid传原始ID（而非格式化后的menuId）
            this.addMenuForm.pid = row.rawMenuId || row.originalId;
            this.addDialogVisible = true;
        },

        resetAddForm() {
            this.addMenuForm = { pid: null, menuName: "", menuType: "M", icon: "", path: "", index: 0, component: "" };
            this.$nextTick(() => this.$refs.addMenuForm?.clearValidate());
        },

        async handleAddSubmit() {
            try {
                await this.$refs.addMenuForm.validate();
                const sortValue = `${this.addMenuForm.pid ?? 0}-${this.addMenuForm.index}`;
                const apiRequestData = {
                    pid: this.addMenuForm.pid,
                    title: this.addMenuForm.menuName,
                    menuType: this.addMenuForm.menuType,
                    path: this.addMenuForm.path,
                    icon: this.addMenuForm.icon,
                    status: "1",
                    sort: this.addMenuForm.index,
                    component: this.addMenuForm.component,
                    index: sortValue,
                    name: (this.addMenuForm.path || '').substring(1),
                };
                const response = await addMenu(apiRequestData);
                if (response && response.code === 200) {
                    this.$message.success("新增成功");
                    this.addDialogVisible = false;
                    this.loadMenuData();
                } else {
                    this.$message.error("新增失败：" + (response.msg || '未知错误'));
                }
            } catch (error) {
                console.error("新增请求异常:", error);
                this.$message.error("新增菜单失败，请重试");
            }
        },

        handleEdit(row) {
            this.editDialogTitle = `修改菜单【${row.menuName}】`;
            const cascaderOptionsCopy = JSON.parse(JSON.stringify(this.cascaderOptions));
            // 过滤时用原始ID（rawMenuId/originalId）
            const filteredOptions = this.removeNodeAndChildren(cascaderOptionsCopy, row.rawMenuId || row.originalId);
            this.cascaderOptions = filteredOptions;

            this.editMenuForm = {
                menuId: row.rawMenuId || row.originalId, // 传原始ID给后端
                parentId: row.parentId,
                menuName: row.menuName,
                menuType: row.menuType,
                icon: row.icon,
                path: row.path,
                index: row.index,
                component: row.component
            };

            this.$nextTick(() => {
                this.editDialogVisible = true;
            });
        },

        removeNodeAndChildren(options, nodeIdToRemove) {
            const targetId = String(nodeIdToRemove);
            return options.filter(option => {
                if (String(option.menuId) === targetId) return false;
                if (option.children && option.children.length > 0) {
                    option.children = this.removeNodeAndChildren(option.children, nodeIdToRemove);
                }
                return true;
            });
        },

        async handleEditSubmit() {
            try {
                await this.$refs.editMenuForm.validate();

                const apiRequestData = {
                    menuId: this.editMenuForm.menuId, // 原始ID
                    pid: this.editMenuForm.parentId,
                    title: this.editMenuForm.menuName,
                    name: (this.editMenuForm.path || '').substring(1),
                    menuType: this.editMenuForm.menuType,
                    path: this.editMenuForm.path,
                    component: this.editMenuForm.component,
                    icon: this.editMenuForm.icon,
                    status: "1",
                    sort: this.editMenuForm.index,
                    index: this.editMenuForm.index
                };

                const response = await editMenu(apiRequestData);
                if (response && response.code === 200) {
                    this.$message.success("修改成功");
                    this.editDialogVisible = false;
                    this.loadMenuData();
                } else {
                    this.$message.error("修改失败：" + (response.msg || '未知错误'));
                }
            } catch (error) {
                console.error("修改请求异常:", error);
                this.$message.error("修改菜单失败，请重试");
            }
        },

        handleDelete(row) {
            this.$confirm(`确定要删除菜单【${row.menuName}】及其所有子菜单吗？`, '提示', {
                confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning'
            }).then(async () => {
                const loading = this.$loading({ text: "删除中..." });
                try {
                    // 删除时传原始ID
                    const response = await deleteMenu({
                        index: row.index,
                        menuId: row.rawMenuId || row.originalId
                    });
                    if (response && response.code === 200) {
                        this.$message.success('删除成功!');
                        this.loadMenuData();
                    } else {
                        this.$message.error('删除失败: ' + (response.msg || '未知错误'));
                    }
                } catch (error) {
                    console.error('删除请求异常:', error);
                    this.$message.error('删除请求异常: ' + (error.message || '网络错误'));
                } finally {
                    loading.close();
                }
            }).catch(() => {
                this.$message.info('已取消删除');
            });
        },

        // 保留：根据临时ID查找原始ID
        getOriginalIdByTempId(data, tempId) {
            for (const item of data) {
                if (item._tempId === tempId) {
                    return item.id || item.menuId;
                }
                if (item.children && item.children.length > 0) {
                    const found = this.getOriginalIdByTempId(item.children, tempId);
                    if (found) return found;
                }
            }
            return null;
        }
    }
};
</script>

<style scoped>
.menu-manage {
    padding: 15px;
    background: #fff;
    min-height: calc(100vh - 70px);
}

.toolbar {
    display: flex;
    align-items: center;
    gap: 10px;
}

.dialog-footer {
    text-align: center;
}

/* 优化表格缩进 */
:deep(.el-table .el-table__indent) {
    flex: 0 0 20px !important;
    width: 20px !important;
}
</style>